import {
  FreeGameWinPresentationControllerBehavior,
  SlotEventConstantsBehavior,
} from "@quest/murka-games-behavior-panther/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { delayedCall, dispatcher, IEvent, ingenuity, killDelayedCall } from "@quest/base-core";
import { GameParserModel } from "../Platform/GameParserModel";
import { Model as platformModel } from "@quest/platform-murka-phase_2/dist";
import { gameConstants } from "../Constants/gameConstants";

export class FreeGameWinPresentationControllerGame extends FreeGameWinPresentationControllerBehavior {
  /**
   * subscribe all events
   */
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.SHOW_FG_SYM_WIN, this.onShowFgSymWin, this);
  }

  /**
   * unsubscribe all events
   */
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.SHOW_FG_SYM_WIN, this.onShowFgSymWin, this);
  }
  /**
   * overrided to add stage click functionality in case of cascading tickup
   */
  protected onStageClickedFG(evt: IEvent): void {
    if (ingenuity.configData.stageClickOnCascade) {
      if ((ingenuity.parserModel as GameParserModel).getCascadingStatus()) {
        dispatcher.fireEvent(SlotEventConstantsBehavior.FORCE_STOP_WIN_METER_TICKUP_FG);
        dispatcher.fireEvent(eventDispatchers.FG_HIDE_QLINE_PLAYER_MSG);
      } else {
        super.onStageClickedFG(evt);
      }
    }
    else {
      super.onStageClickedFG(evt);
    }
  }

  /**
   * This method will show Symbol win frames
   */
  private onShowFgSymWin(evt: IEvent): void {
    if ((ingenuity.parserModel as platformModel).getHasLineWins()) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_ALL_SYMBOL_ANIM);
    }
    delayedCall(
      gameConstants.NEXT_LINE_TOGGLE,
      gameConstants.DELAY_FOR_NEXT_LINE_TOGGLE_TIME,
      () => {
        killDelayedCall(gameConstants.NEXT_LINE_TOGGLE);
        const currentCascadeLineCount: number = (ingenuity.parserModel as GameParserModel).getCascadeLineToggleCount();
        (ingenuity.parserModel as GameParserModel).setCascadeLineToggleCount(currentCascadeLineCount - 1);
        dispatcher.fireEvent(eventDispatchers.CHECK_AND_SHOW_NEXT_CASCADE_PRESENTATION);
      },
      this
    );
  }
}
